interface ToggleProps {
  on: boolean;
  onChange?: (v: boolean) => void;
  "aria-label"?: string;
}

export function Toggle({ on, onChange, "aria-label": ariaLabel }: ToggleProps) {
  return (
    <button
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      onClick={() => onChange?.(!on)}
      className={[
        "relative w-9 h-5 rounded-full border border-border transition-colors duration-150",
        on ? "bg-accent" : "bg-bg-3",
      ].join(" ")}
    >
      <span
        className={[
          "absolute top-0.5 w-3.5 h-3.5 rounded-full bg-white transition-[left] duration-150",
          "shadow-[0_1px_3px_rgba(0,0,0,0.3)]",
          on ? "left-4.5" : "left-0.5",
        ].join(" ")}
      />
    </button>
  );
}
